webpackJsonp([116404443735450],{

/***/ 2562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/step-4.0e44a81f.png";

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _step = __webpack_require__(2562);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 4: Display Loading Experience'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to learn how to use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property in the data structure, and display a loading experience while the list of tweets are being fetched.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'fetching.4' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'The Problem'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While it may happen too quickly to notice, there is a period of time before the list of tweets is displayed when the page simply says "Feed" with nothing underneath.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This happens because the application doesn\'t fetch the tweets until the first time the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component is rendered, and during that render cycle, the component doesn\'t have any data to render.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Showing a blank view is a bad user experience, so let\'s update our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component to display a "loader" while the tweets are being fetched.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'The State Property'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When Lore performs any actions on data (such as fetching, creating, updating or deleting it) the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property of that data is updated to reflect the action being performed.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, the first time our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component is rendered, it requests a collection of tweets using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getState(\'tweet.find\')'
	      ),
	      '. Since this data doesn\'t exist in the local store yet, the framework will invoke an action to fetch it.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'What gets provided to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component at that point is a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets'
	      ),
	      ' prop that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      {\n        state: \'FETCHING\',\n        data: [],\n        query: {}\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property of the data has been set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'FETCHING'
	      ),
	      ' in order to notify you that the data is being fetched. Once the data returns, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property will have a value of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'RESOLVED'
	      ),
	      ' to let you know that the data has been fetched. And if an error occurs while fetching the data, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' property would be updated to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ERROR_FETCHING'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To make it easier to refer to these states, there\'s a file located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/constants/PayloadStates.js'
	      ),
	      ' that contains all the states Lore might assign to data. If you open it, there will a commented out section that shows the default states used by the framework, which are these:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n        INITIAL_STATE: \'INITIAL_STATE\',\n\n        RESOLVED   : \'RESOLVED\',\n        NOT_FOUND: \'NOT_FOUND\',\n        DELETED: \'DELETED\',\n\n        CREATING: \'CREATING\',\n        UPDATING: \'UPDATING\',\n        DELETING: \'DELETING\',\n        FETCHING: \'FETCHING\',\n\n        ERROR_CREATING: \'ERROR_CREATING\',\n        ERROR_UPDATING: \'ERROR_UPDATING\',\n        ERROR_DELETING: \'ERROR_DELETING\',\n        ERROR_FETCHING: \'ERROR_FETCHING\'\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s use this file to create our loading experience.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about this file ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/src/constants/payload-states/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add the Loading Experience'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component and import ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'PayloadStates'
	      ),
	      '. Then update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to display a loading experience when the tweets are being fetched, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/Feed.js\n      ...\n      import PayloadStates from \'../constants/PayloadStates\';\n      ...\n\n        render() {\n          const { tweets } = this.props;\n\n          if (tweets.state === PayloadStates.FETCHING) {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <div className="loader"/>\n              </div>\n            );\n          }\n\n          return (\n            <div className="feed">\n              <h2 className="title">\n                Feed\n              </h2>\n              <ul className="media-list tweets">\n                {tweets.data.map(this.renderTweet)}\n              </ul>\n            </div>\n          );\n        }\n\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here we\'ve added a check if the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.state'
	      ),
	      ' property is equal to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'PayloadStates.FETCHING'
	      ),
	      ', and if it is, then we\'re rendering our loading experience.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Refresh the browser and you ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'might'
	      ),
	      ' see an animated "loader" flash on the screen right before the tweets are rendered. But if you can\'t see it (and you probably can\'t) don\'t worry; later we\'ll connect to a real API server that has an artificial delay, and you\'ll ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'definitely'
	      ),
	      ' see it then.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this when the Feed is loading:'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _step2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Feed.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        export default connect(function(getState, props) {\n          return {\n            tweets: getState(\'tweet.find\')\n          };\n        })(\n        createReactClass({\n          displayName: \'Feed\',\n\n          propTypes: {\n            tweets: PropTypes.object.isRequired\n          },\n\n          getDefaultProps() {\n            const tweet = {\n              id: 1,\n              cid: \'c1\',\n              state: \'RESOLVED\',\n              data: {\n                id: 1,\n                userId: 1,\n                text: \'Nothing can beat science!\',\n                createdAt: \'2018-04-24T05:10:49.382Z\'\n              }\n            };\n\n            return {\n              tweets: {\n                state: \'RESOLVED\',\n                data: [tweet]\n              }\n            };\n          },\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          },\n\n          render() {\n            const { tweets } = this.props;\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n              </div>\n            );\n          }\n\n        })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        class Feed extends React.Component {\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          }\n\n          render() {\n            const { tweets } = this.props;\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        Feed.propTypes = {\n          tweets: PropTypes.object.isRequired\n        };\n\n        Feed.defaultProps = (function() {\n          const tweet = {\n            id: 1,\n            cid: \'c1\',\n            state: \'RESOLVED\',\n            data: {\n              id: 1,\n              userId: 1,\n              text: \'Nothing can beat science!\',\n              createdAt: \'2018-04-24T05:10:49.382Z\'\n            }\n          };\n\n          return {\n            tweets: {\n              state: \'RESOLVED\',\n              data: [tweet]\n            }\n          };\n        })();\n\n        export default connect(function(getState, props) {\n          return {\n            tweets: getState(\'tweet.find\')\n          };\n        })(Feed);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import Tweet from \'./Tweet\';\n\n        @connect(function(getState, props) {\n          return {\n            tweets: getState(\'tweet.find\')\n          };\n        })\n        class Feed extends React.Component {\n\n          static propTypes = {\n            tweets: PropTypes.object.isRequired\n          };\n\n          static defaultProps = (function() {\n            const tweet = {\n              id: 1,\n              cid: \'c1\',\n              state: \'RESOLVED\',\n              data: {\n                id: 1,\n                userId: 1,\n                text: \'Nothing can beat science!\',\n                createdAt: \'2018-04-24T05:10:49.382Z\'\n              }\n            };\n\n            return {\n              tweets: {\n                state: \'RESOLVED\',\n                data: [tweet]\n              }\n            };\n          })();\n\n          renderTweet(tweet) {\n            return (\n              <Tweet key={tweet.id} tweet={tweet} />\n            );\n          }\n\n          render() {\n            const { tweets } = this.props;\n\n            if (tweets.state === PayloadStates.FETCHING) {\n              return (\n                <div className="feed">\n                  <h2 className="title">\n                    Feed\n                  </h2>\n                  <div className="loader"/>\n                </div>\n              );\n            }\n\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {tweets.data.map(this.renderTweet)}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-5/' },
	        'fetch the user for each tweet'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-fetching-step-4-js-51f3c2da7bc96ad8350d.js